import React, { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import styles from './SecondScreen.module.css'
import betty from "../images/תכשיטים בטי בועיות.png"
gsap.registerPlugin(ScrollTrigger)

const ServicesGrid = () => {
  const gridRef = useRef(null)
  const largeCardRef = useRef(null)
  const smallCardsRef = useRef([])

  useEffect(() => {
    const ctx = gsap.context(() => {
      // אנימציה לכרטיס הגדול - מהשמאל עם fade וקצת scale
      gsap.from(largeCardRef.current, {
        scrollTrigger: {
          trigger: largeCardRef.current,
          start: 'top 75%',
          toggleActions: 'play none none reverse'
        },
        opacity: 0,
        x: -80,
        scale: 0.95,
        duration: 1.2,
        ease: 'power2.out'
      })

      // אנימציות ייחודיות לכל כרטיס קטן
      const animations = [
        { x: 60, y: -30, rotation: 3 },    // מימין-למעלה עם סיבוב קל
        { x: -60, y: -30, rotation: -3 },  // משמאל-למעלה עם סיבוב הפוך
        { y: 80, scale: 0.9 },              // מלמטה עם scale
        { x: 60, y: 40, rotation: 2 }      // מימין-למטה עם סיבוב קל
      ]

      smallCardsRef.current.forEach((card, index) => {
        if (card) {
          gsap.from(card, {
            scrollTrigger: {
              trigger: card,
              start: 'top 80%',
              toggleActions: 'play none none reverse'
            },
            opacity: 0,
            ...animations[index],
            duration: 1.1,
            delay: index * 0.12,
            ease: 'power2.out'
          })
        }
      })
    }, gridRef)

    return () => ctx.revert()
  }, [])

  const handleWhatsApp = (serviceName, messageType) => {
    const phoneNumber = '972535277277'
    let message = ''
    
    if (messageType === 'details') {
      message = `היי בטי הגעתי מהדף שלך, אשמח לשמוע עוד על ${serviceName}`
    } else if (messageType === 'booking') {
      message = `היי בטי הגעתי מהדף שלך אשמח לשריין אצלך תור ל${serviceName}`
    }
    
    const encodedMessage = encodeURIComponent(message)
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`
    window.open(whatsappUrl, '_blank')
  }

  return (
    <div ref={gridRef} className={styles.gridContainer}>
      <div ref={largeCardRef} className={styles.largeCard}>
        <div className={styles.textSection}>
          <h3>תכשיטים בעיצוב אישי</h3>
          <p>תכשיטים מינימליסטיים ומדויקים בעבודת יד, שמשדרים יוקרה ומבליטים את הייחוד שלך</p>
          <div className={styles.buttons}>
            <button 
              className={styles.bookBtn}
              onClick={() => handleWhatsApp('תכשיטים בעיצוב אישי', 'booking')}
            >
              לרכישה
            </button>
            <span 
              className={styles.more}
              onClick={() => handleWhatsApp('תכשיטים בעיצוב אישי', 'details')}
            >
              צפי בקולקציות →
            </span>
          </div>
          <img
            src={betty}
            alt="תכשיטים בעיצוב אישי"
            className={styles.image}
          />
        </div>
      </div>
    <div ref={el => smallCardsRef.current[3] = el} className={styles.smallCard}>
        <h3>עיצוב ושיקום גבות</h3>
        <p>התאמה מדויקת למבנה הפנים ושיקום גבות דקות או לא אחידות במראה טבעי</p>
        <div className={styles.buttons}>
          <button 
            className={styles.bookBtn}
            onClick={() => handleWhatsApp('עיצוב ושיקום גבות', 'booking')}
          >
            שרייני תור
          </button>
          <span 
            className={styles.more}
            onClick={() => handleWhatsApp('עיצוב ושיקום גבות', 'details')}
          >
            עוד פרטים →
          </span>
        </div>
      </div>
      

      <div ref={el => smallCardsRef.current[1] = el} className={styles.smallCard}>
        <h3>איפור ערב וכלות</h3>
        <p>מראה יוקרתי ועמיד לאורך כל האירוע עם התאמה מדויקת לסגנון שלך</p>
        <div className={styles.buttons}>
          <button 
            className={styles.bookBtn}
            onClick={() => handleWhatsApp('איפור ערב וכלות', 'booking')}
          >
            שרייני תור
          </button>
          <span 
            className={styles.more}
            onClick={() => handleWhatsApp('איפור ערב וכלות', 'details')}
          >
            עוד פרטים →
          </span>
        </div>
      </div>
<div ref={el => smallCardsRef.current[2] = el} className={styles.smallCard}>
  <h3>איפור קבוע</h3>
  <p>מראה מושלם 24/7 עם איפור קבוע מקצועי לגבות ולשפתיים - חסכו זמן והתעוררו מושלמות</p>
  <div className={styles.buttons}>
    <button 
      className={styles.bookBtn}
      onClick={() => handleWhatsApp('איפור קבוע', 'booking')}
    >
      שרייני תור
    </button>
    <span 
      className={styles.more}
      onClick={() => handleWhatsApp('איפור קבוע', 'details')}
    >
      עוד פרטים →
    </span>
  </div>
  
</div>
<div ref={el => smallCardsRef.current[0] = el} className={styles.smallCard}>
        <h3>שיזוף בהתזה</h3>
        <p>שיזוף אחיד וטבעי בהתזה מקצועית, ללא כתמים ועם גוון מושלם שנשאר יפה לאורך זמן</p>
        <div className={styles.buttons}>
          <button 
            className={styles.bookBtn}
            onClick={() => handleWhatsApp('שיזוף בהתזה', 'booking')}
          >
            שרייני תור
          </button>
          <span 
            className={styles.more}
            onClick={() => handleWhatsApp('שיזוף בהתזה', 'details')}
          >
            עוד פרטים →
          </span>
        </div>
      </div>
  
    </div>
  )
}

export default ServicesGrid